import { ChatGPTMessageType } from "../types/chatGPTType"

export const completion = async(messages: ChatGPTMessageType[],user?:string, strong?:boolean) => {
    const options = {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${process.env.NEXT_PUBLIC_CHATGPT_API_KEY}`,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            "temperature": 0.8,
            "max_tokens": 1500,
            "model" : strong ? process.env.NEXT_PUBLIC_CHATGPT_MODELS_STRONG as string : process.env.NEXT_PUBLIC_CHATGPT_MODELS as string,
            "messages": messages
        })
    }
    const response = await fetch(process.env.NEXT_PUBLIC_CHATGPT_URL as string, options)
    
    const data = await response.json()
    if ( process.env.NODE_ENV==="development" ) {
        console.log("GPT FETCH",data)
    }
    

    if (data && data.choices && data.choices[0].message && data.choices[0].message.content) {
        
        if ( process.env.NODE_ENV==="development" ) {
            console.log("gpt data",data, data.choices[0].message.content)
        }
        return data.choices[0].message.content      
        
    }
    return false
}

export const getCompletion = async(character:string, lat:number,long:number, placeName:string, language:string, user:any) => {    
    const options = {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            'Authorization': "Bearer " + await user?.getIdToken()
        },
        body: JSON.stringify({ 
            character:character,
            lat:lat,
            long:long,
            placeName:placeName 
        })
      }
      const response = await fetch(`/api/${language}/tourism`, options);
    
      try {
        
        const data = await response.json()
        return data.message

      }catch(e){

      }
}

export const getSuggestions = async(character:string, language:string, user:any) => {    
    const options = {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            'Authorization': "Bearer " + await user?.getIdToken()
        },
        body: JSON.stringify({ 
            character:character,
        })
      }
      const response = await fetch(`/api/${language}/ai`, options);
    
      try {
        
        const data = await response.json()
        return data

      }catch(e){

      }
}

export const getAnalysis = async(image:string, language:string, user:any) => {    
    const options = {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            'Authorization': "Bearer " + await user?.getIdToken()
        },
        body: JSON.stringify({ 
            image:image
        })
      }
      const response = await fetch(`/api/${language}/analysis`, options);
    
      try {
        
        const data = await response.json()
        return data.message

      }catch(e){

      }
}

export const genereImage= async(message:string, language:string, user:any) => {    
    const options = {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            'Authorization': "Bearer " + await user?.getIdToken()
        },
        body: JSON.stringify({ 
            message:message,
        })
      }
      const response = await fetch(`/api/${language}/ai/image`, options);
    
      try {
        
        const data = await response.json()
        return data.message

      }catch(e){

      }
}